module.exports = __webpack_public_path__ + "img/shield-check.38acdd8e.svg";